import {
	SOFTWARE_PROJECT,
	toProjectType,
} from '@jira/platform__project-types/src/project-types.tsx';
import { type ApplicationEditions, PREMIUM_EDITION } from '@jira/platform__application-editions/src/edition.tsx';

// Only show if a software project is open and premium
export const isProjectTypeAndEditionSupported = (
	applicationEditions: ApplicationEditions,
	project?: string,
): Boolean => {
	const projectType = toProjectType(project);

	if (!projectType || projectType !== SOFTWARE_PROJECT) {
		return false;
	}

	return applicationEditions.software === PREMIUM_EDITION;
};
